export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "ID", prop: "id" },
    { label: "记录", prop: "message" },
    { label: "操作人", prop: "operation_user", width: 200 },
    {
      label: "创建时间",
      prop: "create_time",
      width: 180,
    },
    // {
    //   label: "操作",
    //   prop: "operation",
    //   width: 200,
    //   slots: "operation",
    //   fixed: "right",
    // },
  ];
}
